import { executeRequest, Request } from '@jfs/network'
import { txnDetailsParserV3 } from './../network/parsers/TxnDetailsParserV3'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { getStartEndDateTimeFromDate } from '../util/util'

const getTxnDetailsV3 = (
  tokens: any,
  userAccessToken: string,
  rrn: string,
  type: any,
  mid: string,
  txnType: any,
  isSmid: boolean,
  transactionDate: string,
) => {
  const { startDateTime, endDateTime } = getStartEndDateTimeFromDate(transactionDate)
  const request: Request<{}> = {
    apiPath: APIEndPoints.txnDetailsV3,
    method: 'POST',
    config: sitConfig(tokens),
    headers: {
      'Content-Type': 'application/json',
      Authorization: userAccessToken,
    },
    body: {
      inputFilter: {
        merchantId: mid,
        transactionType: type,
        transactionId: [rrn],
        responseType: 'ALL',
        isSMID: isSmid ? 'Y' : 'N',
        startDateTime,
        endDateTime,
      },
      configParams: {
        mediaType: 'JSON',
      },
    },
    cache: false,
  }
  return executeRequest(request).then((data) => {
    return txnDetailsParserV3(data, txnType)
  })
}

export { getTxnDetailsV3 }
